import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";
export default {
  props: {
    parentItem: {
      type: Object,
      default: function _default() {}
    },
    theme: String,
    iconSize: Number
  },
  computed: {
    parentName: function parentName() {
      return this.parentItem.name;
    },
    children: function children() {
      return this.parentItem.children;
    },
    textColor: function textColor() {
      return this.theme === 'dark' ? '#fff' : '#495060';
    }
  }
};